
<div class="compass-name" #{{getCompassId()}} [id]="getCompassId()">{{subscription.compassName}}</div>
<div class="list-container">
  <div class="trackable-list">
    

      
        <div class="logging-item-expanded"  *ngFor="let t of getTrackables(subscription)"  [attr.id]="'tId' + t.id">
          <h3  >{{t.name}}</h3>
          <div  class="widget" *ngIf="t.trackableType === 'SYMPTOM'">
            <symptom-widget class="fullWidth" [data]="t" [caller]="me" [clearSubject$]="clearLoggingSubject$" [word1]="'a lot'" [yesterdayLoaded]="yesterdayLoaded" [yesterdayValue]="getYesterdayValue(t.id)"
                            [word2]="'some'" [word3]="'none'"  (callActionSheet)="callTextActionSheet($event)">
            </symptom-widget>
          </div>
          <div   class="widget" *ngIf=" t.trackableType === 'EVIDENCE'">
            <bp-widget *ngIf="t.name.toLowerCase() == 'blood pressure'" [data]="t"  [clearSubject$]="clearLoggingSubject$" [caller]="me" [yesterdayLoaded]="yesterdayLoaded"  [yesterdayValue]="getYesterdayValue(t.id)"
                        [useDummy]="false">
            </bp-widget>
            <evidence-widget *ngIf="t.name.toLowerCase() != 'blood pressure'" class="fullWidth" [data]="t"  [yesterdayValue]="getYesterdayValue(t.id)"
                              [caller]="me"  [clearSubject$]="clearLoggingSubject$" [keyboard]="keyboard" [focusSet]="activeId == t.id" [yesterdayLoaded]="yesterdayLoaded">
            </evidence-widget>
          </div>
          <div class="widget"   *ngIf="(t.trackableType === 'TREATMENT' || t.trackableType === 'ACTION')">
            <treatment-widget class="fullWidth" [data]="t"  
                              [caller]="me"  [clearSubject$]="clearLoggingSubject$" >
            </treatment-widget>
          </div>

      </div>

    <div><br><br><br><br><br><br><br></div>

    </div>

</div>
  <div class="done-button-container">
    <button mat-flat-button (click)="submitLog()" class="done-button" fill="solid" color="primary" expand="block">Done</button>
  </div>



 
  

